import type { ReactNode } from "react";

type Variant = "neutral" | "primary" | "success" | "warning" | "danger" | "info" | "live";

export function Badge({
  variant = "neutral",
  children,
}: {
  variant?: Variant;
  children: ReactNode;
}) {
  return <span className={`badge badge--${variant}`}>{children}</span>;
}
